import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    NavigationSwitch as SwitchNavigationMutation,
    NavigationSwitchVariables as SwitchNavigationMutationVariables,
    NavigationSwitchInput,
} from 'nutshell-graphql-types';

import SWITCH_NAVIGATION from '../mutations/switch-navigation.graphql';

export const useSwitchNavigation = (): {
    switchNavigation: (input: NavigationSwitchInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [switchNavigation, {loading, error}] = useMutation<
        SwitchNavigationMutation,
        SwitchNavigationMutationVariables
    >(SWITCH_NAVIGATION);

    return {
        switchNavigation: (input: NavigationSwitchInput) => {
            return switchNavigation({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
